module.exports = __webpack_public_path__ + "img/curriculum.fd39e18f.jpg";